import { MD5 } from 'crypto-js';
import { post } from '../utils';

/**
 * 请求缓存/队列
 */
export class RequestCache {
    cache: { [key: string]: Promise<any> };

    constructor() {
        this.cache = {};
    }

    /**
     * 发送请求
     * @param url
     * @param data
     * @param config
     * @param config.options
     * @param config.customHandleErrorCodes
     * @param config.customHandleHttpCodes
     * @returns
     */
    request = (
        url: string,
        data?: object,
        config: {
            options?: object;
            customHandleErrorCodes?: number[];
            customHandleHttpCodes?: number[];
        } = {}
    ) => {
        const cacheKey = MD5(
            JSON.stringify({
                u: url,
                d: data
            })
        ).toString();
        let cache = this.readCache(cacheKey);
        if (!cache) {
            cache = this.addCache(cacheKey, post(url, data, config));
        }
        return cache;
    };

    /**
     * 添加缓存
     *
     * @param key
     * @param request
     */
    addCache(key: string, request: Promise<any>) {
        this.cache[key] = request;
        return request;
    }

    /**
     * 清空缓存
     */
    clearCache() {
        this.cache = {};
    }

    /**
     * 读取缓存
     *
     * @param key
     */
    readCache(key: string) {
        return this.cache[key];
    }
}

export const requestCache = new RequestCache();
